<template>
    <div class="content">
        <slot />
    </div>
</template>

<script>
    export default {
        componentName: "content"
    }
</script>

<style type="text/less" lang="less" scoped>
    @import "../../assets/style/color";
    @import "../../assets/style/config";
    @import "../../assets/style/mixin";

    .content{
        width:@visual-width;
        margin:0 auto;
    }
</style>